module.exports = {
	"id": "wdwd.item.quantity.update",
	"description": "SKU库存修改",
	"meta": {
		"oauth": true
	},
	"requests": {
		"urls": [
			{
				"name": "正式环境",
				"http": "http://openapi.wdwd.com/api/gateway?method=wdwd.item.quantity.update",
				"https": "https://openapi.wdwd.com/api/gateway?method=wdwd.item.quantity.update"
			},
			{
				"name": "沙箱环境",
				"http": "http://openapi.sandbox.wdwd.com/api/gateway?method=wdwd.item.quantity.update",
				"https": "https://openapi.sandbox.wdwd.com/api/gateway?method=wdwd.item.quantity.update"
			}
		],
		"params": {
			"share": [],
			"private": [
				{
					"name": "num_iid",
					"type": "string",
					"required": true,
					"description": "商品id"
				},
				{
					"name": "sku_id",
					"type": "string",
					"required": true,
					"description": "SKU的id。如果不填默认修改宝贝的库存，如果填上则修改该SKU的库存"
				},
				{
					"name": "quantity",
					"type": "number",
					"required": true,
					"description": "库存修改值，必选。当全量更新库存时，quantity必须为大于等于0的正整数；当增量更新库存时，quantity为整数，可小于等于0。若增量更新时传入的库存为负数，则负数与实际库存之和不能小于0。比如当前实际库存为1，传入增量更新quantity=-1，库存改为0"
				},
				{
					"name": "type",
					"type": "number",
					"required": false,
					"description": "库存更新方式，可选。1为全量更新，2为增量更新。如果不填，默认为全量更新"
				}
			]
		}
	},
	"responses": {
		"exceptions": [],
		"params": [
			{
				"name": "items",
				"type": "items",
				"description": "sku库存修改"
			}
		]
	},
	"structure": [
		{
			"name": "items",
			"params": [
				{
					"name": "modified",
					"type": "datetime",
					"enumerable": false,
					"description": "修改时间"
				},
				{
					"name": "num_iid",
					"type": "string",
					"enumerable": false,
					"description": "商品ID"
				},
				{
					"name": "quantity",
					"type": "number",
					"enumerable": false,
					"description": "修改后的库存数"
				},
				{
					"name": "sku_id",
					"type": "string",
					"enumerable": false,
					"description": "sku ID"
				}
			]
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/data/api/wdwd.item.quantity.update.json
 ** module id = 524
 ** module chunks = 1
 **/